import React from "react";
import { motion } from "framer-motion";
import { CtaButton } from "./CtaButton";
import { IMAGES } from "./constants";
import { DownloadIcon, ShieldCheckIcon, InfinityIcon, CreditCardIcon } from "lucide-react";
const guarantees = [{
  icon: DownloadIcon,
  label: "Descarga inmediata"
}, {
  icon: CreditCardIcon,
  label: "Pago único"
}, {
  icon: InfinityIcon,
  label: "Acceso de por vida"
}, {
  icon: ShieldCheckIcon,
  label: "Garantía de 7 días"
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-navy-800 px-5 pb-12 pt-8 text-white sm:pt-10" data-id="element-101" data-mp="x9ur5oc5w29d">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-brand/20 blur-3xl" data-id="element-102" data-mp="saruar6c52ch" />
      <div className="pointer-events-none absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-brand/10 blur-3xl" data-id="element-103" data-mp="nb6kflpmn9kz" />

      <div className="relative mx-auto flex max-w-md flex-col items-center text-center" data-id="element-104" data-mp="3d33fx1m3uzmc">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-5 flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-[11px] font-bold uppercase tracking-widest text-brand-light" data-id="element-105" data-mp="381nv9anuav4h">
          Sistema Antirrefinamientos™
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="font-display text-[28px] font-extrabold leading-[1.12] sm:text-4xl" data-id="element-106" data-mp="3e9fsjg47kcn9">
          Reduce los Refinamientos y{" "}
          <span className="text-brand-light" data-id="element-107" data-mp="35audvw1uxhrr">Aumenta la Predictibilidad</span> de Tus Casos con Alineadores
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.12
      }} className="mt-4 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-108" data-mp="2viol4k3s6wbi">
          El sistema clínico de consulta rápida que te ayuda a detectar los errores antes de que
          aparezcan, optimizar cada planificación y finalizar más tratamientos con{" "}
          <strong className="text-white" data-id="element-109" data-mp="natb7mfw54pz">menos tiempo, menos complicaciones y mayor rentabilidad.</strong>
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.18
      }} src={IMAGES.mockup} alt="Sistema Antirrefinamientos - 6 tomos clínicos, tablet, teléfono y mapa de decisión" className="my-7 w-full max-w-sm drop-shadow-2xl" data-id="element-110" data-mp="id050tel8app" />

        <div id="floating-cta-trigger" className="w-full" data-id="element-111" data-mp="112pv537eo8ba">
          <CtaButton data-id="element-112" data-mp="11154hoo7p9ip">Quiero el Sistema Antirrefinamientos™</CtaButton>
        </div>

        <div className="mt-5 grid w-full grid-cols-2 gap-3" data-id="element-113" data-mp="x0cq6h0hgefk">
          {guarantees.map(g => <div key={g.label} className="flex items-center justify-center gap-1.5 rounded-xl bg-white/5 px-2 py-2 text-[11px] font-semibold text-white/80 sm:text-xs" data-id="element-114" data-mp="3ltqeji9dp5w5">
              <g.icon className="h-4 w-4 shrink-0 text-brand-light" data-id="element-115" data-mp="1xaw06rmvemay" />
              {g.label}
            </div>)}
        </div>
      </div>
    </section>;
}